import { StyleRules } from '@material-ui/core/styles';
import { DialogClassKey } from '@material-ui/core/Dialog';

export const MuiDialog: Partial<StyleRules<DialogClassKey>> = {
  paper: {
    borderRadius: 16,
  },
  paperWidthXs: {
    borderRadius: 8,
  },
  paperWidthSm: {
    borderRadius: 12,
  },
};
